import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, setAdminToken } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Loader2, Lock } from "lucide-react";

export default function AdminLogin() {
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/admin/login", { password });
      setAdminToken(data.token);
      toast.success("Welcome back");
      nav("/admin");
    } catch {
      toast.error("Invalid password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      data-testid="admin-login-page"
      className="min-h-screen flex items-center justify-center bg-[color:var(--brand-surface-alt)] p-6"
    >
      <form
        onSubmit={submit}
        className="w-full max-w-sm bg-[color:var(--brand-surface)] border border-[color:var(--brand-border)] p-8 space-y-5"
      >
        <div className="flex items-center gap-3">
          <Lock className="w-5 h-5 text-[color:var(--brand-primary)]" />
          <div>
            <div className="overline">Restricted</div>
            <h1 className="font-heading text-2xl">Admin sign-in</h1>
          </div>
        </div>
        <div>
          <Label htmlFor="pw">Password</Label>
          <Input
            id="pw"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            data-testid="admin-password-input"
            autoFocus
            required
          />
        </div>
        <Button className="btn-primary w-full" disabled={loading} data-testid="admin-login-btn">
          {loading && <Loader2 className="w-4 h-4 animate-spin" />}
          Sign in
        </Button>
        <p className="text-xs text-[color:var(--brand-text-soft)] text-center">
          For staff only. Password is provisioned by the site administrator.
        </p>
      </form>
    </div>
  );
}
